// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1yHgv","resendInfoText":"OnGoingPaymentBox_resendInfoText__2haBh"};